import IDeal from '@/creditflowresearch/domain/vo/IDeal';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';
import { GrantContext } from '@/creditflowresearch/application/User/access/grants/IAccessGrant';

type TDeal = IDeal | ICorporateDeal;

/**
 * How a deal maps onto an access grant context. Both the deal card (client) and the
 * server-side tiles resolve the grant from this, so they always agree — a tile that
 * renders for an open deal must have been fetched as an open deal too.
 *
 * A deal belongs to a market through its tranches — `cfr.deal.get_by_view_id` carries
 * `tranches[].markets`. Market and region are separate axes: a European Market deal can
 * sit outside EMEA, and an EMEA deal can belong to the US or APAC market. Regions are the
 * deal's own region plus the region of its country, which the backend always keeps among
 * the deal's regions.
 *
 * TODO: remove when the European market opening period ends
 */
export const getDealGrantContext = (deal?: TDeal | null): Partial<GrantContext> => ({
  dealMarketIds: [
    ...new Set((deal?.tranches ?? []).flatMap((tranche) => (tranche.markets ?? []).map(({ id }) => id))),
  ],
  productIds: deal?.product?.id ? [deal.product.id] : [],
  regionIds: [...new Set([deal?.regionId, deal?.country?.region?.id])]
    .filter((id): id is string => Boolean(id)),
});
